<template>
  <v-card class="pa-5" outlined>
    <div class="d-flex justify-space-between align-center mb-2">
      <h3>Desempenho geral</h3>
      <v-spacer></v-spacer>
      <v-select
        label="Filtrar por"
        v-model="filterBy"
        outlined
        dense
        style="max-width: 160px;"
        :items="['Todos', 'Com UTMs', 'Acessos diretos']"
        hide-details
      ></v-select>
    </div>
    <apexchart class="mt-5" type="line" height="322" :options="chartOptions" :series="chartData.values"></apexchart>
  </v-card>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  props: ['value', 'range', 'link'],
  data () {
    return {
      desempenho: true,
      filterBy: 'Todos'
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    period () {
      return moment(this.range[0]).diff(moment(this.range[1]), 'days') * -1 > 30 ? 'month' : 'day'
    },
    isActivePlan () {
      return moment(this.user.active_plan_at || 0).valueOf() > Date.now()
    },
    cards () {
      return (this.link.clicks || []).reduce((data, item) => {
        data.clicks += item.clicks || 0
        data.redirects += item.redirects || 0

        return data
      }, {
        clicks: 0,
        redirects: 0
      })
    },
    chartOptions () {
      return {
        chart: {
          height: 350,
          type: 'line',
          animations: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false,
          formatter: this.$options.filters.number
        },
        stroke: {
          width: [3, 3],
          curve: 'smooth'
        },
        colors: this.link.mode !== 'direct' ? ['#2196f3', '#4CAF50'] : ['#4CAF50'],
        xaxis: {
          categories: this.chartData.labels
        },
        markers: {
          size: 5,
          hover: {
            size: 6
          }
        },
        yaxis: [{
          title: {
            text: 'Volume',
          },
          labels: {
            formatter: this.$options.filters.number
          }
        }]
      }
    },
    chartData () {
      const period = []

      if (this.period === 'day') {
        let date = moment(this.range[0])
        while (date.valueOf() <= moment(this.range[1]).valueOf()) {
          period.push(date.format('DD/MM'))
          date.add(1, 'days')
        }
      } else if (this.period === 'month') {
        let date = moment(this.range[0])

        while (date.valueOf() <= moment(this.range[1]).valueOf()) {
          period.push(date.format('MMM/YY'))
          date.add(1, 'months')
        }

        period.push(date.format('MMM/YY'))
      }

      const data = this.link.clicks.reduce((data, click) => {
        if (this.filterBy === 'Com UTMs' && !click.utm_source) {
          return data
        }

        if (this.filterBy === 'Acessos diretos' && click.utm_source) {
          return data
        }

        let format = 'DD/MM [às] HH[h]'

        if (this.period === 'day') {
          format = 'DD/MM'
        } else if (this.period === 'month') {
          format = 'MMM/YY'
        }

        const date = moment(click.created_at).format(format)

        data.clicks[date] = data.clicks[date] || 0
        data.clicks[date] += click.views
        data.redirects[date] = data.redirects[date] || 0
        data.redirects[date] += click.redirects

        return data
      }, {
        clicks: {},
        redirects: {}
      })

      const values = []

      if (this.link.mode !== 'direct') {
        values.push({
          name: 'Acessos',
          type: 'line',
          data: period.map(item => data.clicks[item] || 0)
        })
      }

      values.push({
        name: 'Redirecionamentos',
        type: 'line',
        data: period.map(item => data.redirects[item] || 0)
      })

      return {
        labels: period.map(item => item[0].toUpperCase() + item.substr(1)),
        values
      }
    }
  },
  watch: {
    period: function () {
      this.desempenho = false
      setImmediate(() => this.desempenho = true)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>